<template>
  <tr>
    <td>{{ item.Name }}</td>
    <td>{{activeEmployeeCount}}</td>
    <!-- 以下手機版不顯示 -->
    <!-- <td v-show="!isMobile">{{ departmentName }}</td> -->
    <!-- 以上手機版不顯示 -->
    <td v-if="canEditDepartment">
      <v-icon
        class="ml-1 mr-1"
        @click.stop="editItem"
      >edit</v-icon>

      <v-tooltip
        top
        v-if="!canDeleteThisDepartment"
      >
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-icon
              class="ml-1 mr-1"
              :disabled="true"
            >delete</v-icon>
          </span>
        </template>
        <span>無法刪除，部門仍有員工</span>
      </v-tooltip>
      <v-icon
        v-else
        class="ml-1 mr-1"
        @click.stop="confirmDeleteItem"
      >delete</v-icon>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    activeEmployeeCount() {
      const findUserDepartmentID = user =>
        (this.userDepartments.find(o => o.UserID == user.ID) || {})
          .DepartmentID;
      return this.users
        .filter(o => o.IsActive)
        .filter(o => findUserDepartmentID(o) == this.item.ID).length;
    },
    canDeleteThisDepartment() {
      return this.activeEmployeeCount <= 0;
    },
    ...mapGetters([
      "canEditDepartment",
      "users",
      "userDepartments",
      "activeUsers"
    ])
  },
  methods: {
    editItem() {
      this.$emit("edit", this.item.ID);
    },
    confirmDeleteItem() {
      if (!confirm("確定刪除「" + (this.item.Name || "") + "」?")) return;
      this.$emit("remove", this.item);
    }
  }
};
</script>